import {computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import FormField from "../../forms/fields/FormField";
import SaporeForm from "../../forms/SaporeForm";
import {default as handleErrorToast} from "../../components/toast/ErrorToast";
import {default as handleSuccessToast} from "../../components/toast/SuccessToast";

export default class SupportFeature {
    constructor(application, navigator) {
        this._application = application;
        this._navigator = navigator;
        this._disableDateForm = null;
        this._orderConfirmationDateForm = null;
        this._importInvoicesManuallyDateForm = null;
        this._synchronizeInvoicesManuallyDateForm = null;
        this._synchronizeCreditNotesManuallyDateForm = null;
        this._synchronizeAccountingDocumentsManuallyDateForm = null;
        this._synchronizeReceiptsManuallyDateForm = null;
        this._synchronizeDebitNotesManuallyDateForm = null;
        this._synchronizeWitholdingCertificatesManuallyDateForm = null;
        this._synchronizeDocumentApplicationsManuallyDateForm = null;
        this._synchronizeOrderStatesManuallyDateForm = null;
        this._loaded = false;
        this._buttonsLoading = false;

        makeObservable(this, {
            _disableDateForm: observable,
            _orderConfirmationDateForm: observable,
            _importInvoicesManuallyDateForm: observable,
            _synchronizeInvoicesManuallyDateForm: observable,
            _synchronizeCreditNotesManuallyDateForm: observable,
            _synchronizeOrderStatesManuallyDateForm: observable,
            _synchronizeAccountingDocumentsManuallyDateForm: observable,
            _synchronizeReceiptsManuallyDateForm: observable,
            _synchronizeDebitNotesManuallyDateForm: observable,
            _synchronizeWitholdingCertificatesManuallyDateForm: observable,
            _synchronizeDocumentApplicationsManuallyDateForm: observable,
            _loaded: observable,
            _buttonsLoading: observable,
            buttonsLoading: computed
        })
    }

    async load() {
        this._createDisableDateForm()
        this._createOrderConfirmationDateForm()
        this._createImportInvoicesManuallyDateForm()
        this._createSynchronizeInvoicesManuallyDateForm()
        this._createSynchronizeCreditNotesManuallyDateForm()
        this._createSynchronizeOrderStatesManuallyDateForm()
        this._createSynchronizeAccountingDocumentsManuallyDateForm()
        this._createSynchronizeReceiptsManuallyDateForm()
        this._createSynchronizeDebitNotesManuallyDateForm()
        this._createSynchronizeWitholdingCertificatesManuallyDateForm()
        this._createSynchronizeDocumentApplicationsManuallyDateForm()
        this._finishedLoading()
    }

    _finishedLoading() {
        this._loaded = true;
    }

    _simulateProcessingDelay() {
        setTimeout(() => {
            this._enableButtons();
        }, 3000); // 3000 ms = 3 seconds
    }

    _enableButtons() {
        this._buttonsLoading = false;
    }

    _disableButtons() {
        this._buttonsLoading = true;
    }

    _createDisableDateForm() {
        const fields = {
            "disabledDate": new FormField(false),
        }
        this.disableDateForm = new SaporeForm(fields)
    }

    _createOrderConfirmationDateForm() {
            const fields = {
                "orderConfirmationDate": new FormField(false),
            }
            this.orderConfirmationDateForm = new SaporeForm(fields)
        }

    _createImportInvoicesManuallyDateForm() {
        const fields = {
            "importInvoicesManuallyDate": new FormField(false),
        }
        this.importInvoicesManuallyDateForm = new SaporeForm(fields)
    }

    _createSynchronizeInvoicesManuallyDateForm() {
        const fields = {
            "synchronizeInvoicesManuallyDate": new FormField(false),
        }
        this.synchronizeInvoicesManuallyDateForm = new SaporeForm(fields)
    }

    _createSynchronizeOrderStatesManuallyDateForm() {
        const fields = {
            "synchronizeOrderStatesManuallyDate": new FormField(false),
        }
        this.synchronizeOrderStatesManuallyDateForm = new SaporeForm(fields)
    }

    _createSynchronizeAccountingDocumentsManuallyDateForm() {
        const fields = {
            "synchronizeAccountingDocumentsManuallyDate": new FormField(false),
        }
        this.synchronizeAccountingDocumentsManuallyDateForm = new SaporeForm(fields)
    }

    _createSynchronizeCreditNotesManuallyDateForm() {
        const fields = {
            "synchronizeCreditNotesManuallyDate": new FormField(false),
        }
        this.synchronizeCreditNotesManuallyDateForm = new SaporeForm(fields)
    }

    _createSynchronizeReceiptsManuallyDateForm() {
        const fields = {
            "synchronizeReceiptsManuallyDate": new FormField(false),
        }
        this.synchronizeReceiptsManuallyDateForm = new SaporeForm(fields)
    }

    _createSynchronizeDebitNotesManuallyDateForm() {
        const fields = {
            "synchronizeDebitNotesManuallyDate": new FormField(false),
        }
        this.synchronizeDebitNotesManuallyDateForm = new SaporeForm(fields)
    }

    _createSynchronizeWitholdingCertificatesManuallyDateForm() {
        const fields = {
            "synchronizeWitholdingCertificatesManuallyDate": new FormField(false),
        }
        this.synchronizeWitholdingCertificatesManuallyDateForm = new SaporeForm(fields)
    }

    _createSynchronizeDocumentApplicationsManuallyDateForm() {
        const fields = {
            "synchronizeDocumentApplicationsManuallyDate": new FormField(false),
        }
        this.synchronizeDocumentApplicationsManuallyDateForm = new SaporeForm(fields)
    }

    disabledDateField() {
        return this.disableDateForm.getFieldByName("disabledDate")
    }

    orderConfirmationDateField() {
        return this.orderConfirmationDateForm.getFieldByName("orderConfirmationDate")
    }

    importInvoicesManuallyDateField() {
        return this.importInvoicesManuallyDateForm.getFieldByName('importInvoicesManuallyDate')
    }

    synchronizeOrderStatesManuallyDateField() {
        return this.synchronizeOrderStatesManuallyDateForm.getFieldByName('synchronizeOrderStatesManuallyDate')
    }

    synchronizeInvoicesManuallyDateField() {
        return this.synchronizeInvoicesManuallyDateForm.getFieldByName('synchronizeInvoicesManuallyDate')
    }

    synchronizeAccountingDocumentsManuallyDateField() {
        return this.synchronizeAccountingDocumentsManuallyDateForm.getFieldByName('synchronizeAccountingDocumentsManuallyDate')
    }

    synchronizeCreditNotesManuallyDateField() {
        return this.synchronizeCreditNotesManuallyDateForm.getFieldByName('synchronizeCreditNotesManuallyDate')
    }

    synchronizeReceiptsManuallyDateField() {
        return this.synchronizeReceiptsManuallyDateForm.getFieldByName('synchronizeReceiptsManuallyDate')
    }

    synchronizeDebitNotesManuallyDateField() {
        return this.synchronizeDebitNotesManuallyDateForm.getFieldByName('synchronizeDebitNotesManuallyDate')
    }

    synchronizeWitholdingCertificatesManuallyDateField() {
        return this.synchronizeWitholdingCertificatesManuallyDateForm.getFieldByName('synchronizeWitholdingCertificatesManuallyDate')
    }

    synchronizeDocumentApplicationsManuallyDateField() {
        return this.synchronizeDocumentApplicationsManuallyDateForm.getFieldByName('synchronizeDocumentApplicationsManuallyDate')
    }

    disableDate() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._simulateProcessingDelay();
                handleSuccessToast('Fecha deshabilitada con éxito')
            },
            handlesError: (response) => {
                this._simulateProcessingDelay()
                handleErrorToast('No se pudo deshabilitar la fecha')
            }
        });
        this._disableButtons()
        const date = this.disabledDateField().value;
        return this._application.apiClient().disableDate(date, responseHandler)
    }

    synchronizeERP() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._simulateProcessingDelay()
                handleSuccessToast('Sincronización finalizada con éxito')
            },
            handlesError: (response) => {
                this._simulateProcessingDelay()
                handleErrorToast('Fallo en la sincronización')
            }
        });
        this._disableButtons()
        return this._application.apiClient().synchronizeWithERP(responseHandler)
    }

    recalculateCurrentAccounts() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._simulateProcessingDelay()
                handleSuccessToast('Recálculo finalizado con éxito')
            },
            handlesError: (response) => {
                this._simulateProcessingDelay()
                handleErrorToast('Fallo en el recálculo')
            }
        });
        this._disableButtons()
        return this._application.apiClient().recalculateCurrentAccounts(responseHandler)
    }

    emailMissingApplicationDocuments() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._simulateProcessingDelay()
                handleSuccessToast('Se envió el mail de comprobantes faltantes')
            },
            handlesError: (response) => {
                this._simulateProcessingDelay()
                handleErrorToast('No se pudo enviar el mail de comprobantes faltantes')
            }
        });
        this._disableButtons()
        return this._application.apiClient().emailMissingApplicationDocuments(responseHandler)
    }

    importInvoicesManuallyDate() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._simulateProcessingDelay()
                handleSuccessToast('Facturas importadas con éxito')
            },
            handlesError: (response) => {
                this._simulateProcessingDelay()
                handleErrorToast('No se pudo importar todas las facturas')
            }
        });
        this._buttonsLoading = true
        const date = this.importInvoicesManuallyDateField().value;
        return this._application.apiClient().importInvoicesManuallyByDate(date, responseHandler)
    }

    synchronizeInvoicesManuallyForDate() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._simulateProcessingDelay()
                handleSuccessToast('Facturas importadas con éxito')
            },
            handlesError: (response) => {
                this._simulateProcessingDelay()
                handleErrorToast('No se pudo importar todas las facturas')
            }
        });
        this._buttonsLoading = true
        const date = this.synchronizeInvoicesManuallyDateField().value;
        return this._application.apiClient().synchronizeInvoicesManuallyByDate(date, responseHandler)
    }

    synchronizeOrderStatesManuallyForDate() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._simulateProcessingDelay()
                handleSuccessToast('Estado de pedidos sincronizados con éxito')
            },
            handlesError: (response) => {
                this._simulateProcessingDelay()
                handleErrorToast('No se sincronizar el estado de los pedidos')
            }
        });
        this._buttonsLoading = true
        const date = this.synchronizeOrderStatesManuallyDateField().value;
        return this._application.apiClient().synchronizeOrderStatesManuallyForDate(date, responseHandler)
    }

    synchronizeAccountingDocumentsManuallyForDate() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._simulateProcessingDelay()
                handleSuccessToast('Documentos contables sincronizados con éxito')
            },
            handlesError: (response) => {
                this._simulateProcessingDelay()
                handleErrorToast('No se sincronizaron los documentos contables')
            }
        });
        this._buttonsLoading = true
        const date = this.synchronizeAccountingDocumentsManuallyDateField().value;
        return this._application.apiClient().synchronizeAccountingDocumentsManuallyForDate(date, responseHandler)
    }

    synchronizeDocumentApplicationsManuallyForDate() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._simulateProcessingDelay()
                handleSuccessToast('Aplicaciones de documentos sincronizadas con éxito')
            },
            handlesError: (response) => {
                this._simulateProcessingDelay()
                handleErrorToast('No se sincronizaron las aplicaciones de documentos')
            }
        });
        this._buttonsLoading = true
        const date = this.synchronizeDocumentApplicationsManuallyDateField().value;
        return this._application.apiClient().synchronizeDocumentApplicationsManuallyForDate(date, responseHandler)
    }

    synchronizeCreditNotesManuallyForDate() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._simulateProcessingDelay()
                handleSuccessToast('Notas de crédito sincronizadas con éxito')
            },
            handlesError: (response) => {
                this._simulateProcessingDelay()
                handleErrorToast('No se sincronizaron las notas de crédito')
            }
        });
        this._buttonsLoading = true
        const date = this.synchronizeCreditNotesManuallyDateField().value;
        return this._application.apiClient().synchronizeCreditNotesManuallyForDate(date, responseHandler)
    }

    synchronizeReceiptsManuallyForDate() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._simulateProcessingDelay()
                handleSuccessToast('Recibos sincronizados con éxito')
            },
            handlesError: (response) => {
                this._simulateProcessingDelay()
                handleErrorToast('No se sincronizaron los recibos')
            }
        });
        this._buttonsLoading = true
        const date = this.synchronizeReceiptsManuallyDateField().value;
        return this._application.apiClient().synchronizeReceiptsManuallyForDate(date, responseHandler)
    }

    synchronizeDebitNotesManuallyForDate() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._simulateProcessingDelay()
                handleSuccessToast('Notas de débito sincronizadas con éxito')
            },
            handlesError: (response) => {
                this._simulateProcessingDelay()
                handleErrorToast('No se sincronizaron las notas de débito')
            }
        });
        this._buttonsLoading = true
        const date = this.synchronizeDebitNotesManuallyDateField().value;
        return this._application.apiClient().synchronizeDebitNotesManuallyForDate(date, responseHandler)
    }

    synchronizeWitholdingCertificatesManuallyForDate() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._simulateProcessingDelay()
                handleSuccessToast('Certificados de retención sincronizados con éxito')
            },
            handlesError: (response) => {
                this._simulateProcessingDelay()
                handleErrorToast('No se sincronizaron los certificados de retención')
            }
        });
        this._buttonsLoading = true
        const date = this.synchronizeWitholdingCertificatesManuallyDateField().value;
        return this._application.apiClient().synchronizeWitholdingCertificatesManuallyForDate(date, responseHandler)
    }

    synchronizeAdjustments() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._simulateProcessingDelay()
                handleSuccessToast('Ajustes sincronizados con éxito')
            },
            handlesError: (response) => {
                this._simulateProcessingDelay()
                handleErrorToast('No se sincronizaron los ajustes')
            }
        });
        this._disableButtons()
        return this._application.apiClient().synchronizeAdjustments(responseHandler)
    }

    get buttonsLoading() {
        return this._buttonsLoading;
    }

    set buttonsLoading(value) {
        this._buttonsLoading = value
    }

    confirmOrdersOnSelectedDate() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._simulateProcessingDelay()
                handleSuccessToast('Fecha confirmada con éxito')
            },
            handlesError: (response) => {
                this._simulateProcessingDelay()
                return handleErrorToast('No se pudo confirmar la fecha')
            }
        });
        this._disableButtons()
        const orderConfirmationDateField = this.orderConfirmationDateField()
        return this._application.apiClient().confirmOrdersOn(orderConfirmationDateField.value, responseHandler)
    }

    get disableDateForm() {
        return this._disableDateForm;
    }

    set disableDateForm(value) {
        this._disableDateForm = value;
    }

    get orderConfirmationDateForm() {
        return this._orderConfirmationDateForm;
    }

    set orderConfirmationDateForm(value) {
        this._orderConfirmationDateForm = value;
    }

    get importInvoicesManuallyDateForm() {
        return this._importInvoicesManuallyDateForm;
    }

    set importInvoicesManuallyDateForm(value) {
        return this._importInvoicesManuallyDateForm = value;
    }
    get synchronizeOrderStatesManuallyDateForm() {
        return this._synchronizeOrderStatesManuallyDateForm;
    }

    set synchronizeOrderStatesManuallyDateForm(value) {
        return this._synchronizeOrderStatesManuallyDateForm = value;
    }

    get synchronizeInvoicesManuallyDateForm() {
        return this._synchronizeInvoicesManuallyDateForm;
    }

    get synchronizeAccountingDocumentsManuallyDateForm() {
        return this._synchronizeAccountingDocumentsManuallyDateForm;
    }

    set synchronizeAccountingDocumentsManuallyDateForm(value) {
        return this._synchronizeAccountingDocumentsManuallyDateForm = value;
    }

    get synchronizeCreditNotesManuallyDateForm() {
        return this._synchronizeCreditNotesManuallyDateForm;
    }

    set synchronizeCreditNotesManuallyDateForm(value) {
        return this._synchronizeCreditNotesManuallyDateForm = value;
    }

    get synchronizeReceiptsManuallyDateForm() {
        return this._synchronizeReceiptsManuallyDateForm;
    }

    set synchronizeReceiptsManuallyDateForm(value) {
        return this._synchronizeReceiptsManuallyDateForm = value;
    }

    get synchronizeDebitNotesManuallyDateForm() {
        return this._synchronizeDebitNotesManuallyDateForm;
    }

    set synchronizeDebitNotesManuallyDateForm(value) {
        return this._synchronizeDebitNotesManuallyDateForm = value;
    }

    get synchronizeWitholdingCertificatesManuallyDateForm() {
        return this._synchronizeWitholdingCertificatesManuallyDateForm;
    }

    set synchronizeWitholdingCertificatesManuallyDateForm(value) {
        return this._synchronizeWitholdingCertificatesManuallyDateForm = value;
    }

    get synchronizeDocumentApplicationsManuallyDateForm() {
        return this._synchronizeDocumentApplicationsManuallyDateForm;
    }

    set synchronizeDocumentApplicationsManuallyDateForm(value) {
        return this._synchronizeDocumentApplicationsManuallyDateForm = value;
    }

    set synchronizeInvoicesManuallyDateForm(value) {
        return this._synchronizeInvoicesManuallyDateForm = value;
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }
}